import React from "react";
import { Row, Form, Col } from "react-bootstrap";
import { labels } from "../../../../../../../../localization/labels";
import SubmitControl from "../../../../../../../core/SubmitControl";
import DropDown from "../../../../../../../core/DropDown";

const ClassificationGeneralData = props => {
  return (
    <Form>
      <br></br>
      <Form.Group controlId="name" className="distance-from-tab">
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.name}</Form.Label>
          </Col>
          <Col>
            <SubmitControl
              autoFocus
              type="text"
              placeholder={labels.namePlaceholder}
              value={props.entity.name}
              validationRule={props.validationRules.name}
              onChange={props.onChange}
              maxLength={props.maxLength.name}
            ></SubmitControl>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group controlId="code">
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.code}</Form.Label>
          </Col>
          <Col>
            <SubmitControl
              placeholder={labels.codePlaceholder}
              value={props.entity.code}
              onChange={props.onChange}
              maxLength={props.maxLength.code}
            ></SubmitControl>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group controlId="description">
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.description}</Form.Label>
          </Col>
          <Col>
            <SubmitControl
              as="textarea"
              placeholder={labels.descriptionPlaceholder}
              value={props.entity.description}
              onChange={props.onChange}
              maxLength={props.maxLength.description}
            ></SubmitControl>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group controlId="dateFromTo">
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.dateFromTo}</Form.Label>
          </Col>
          <Col>
            <SubmitControl
              type="dateRange"
              placeholder={[
                labels.dateFromPlaceholder,
                labels.dateToPlaceholder
              ]}
              validationRule={
                props.validationRules && props.validationRules.dateFromTo
              }
              value={props.entity.dateFromTo}
              onChange={props.onChange}
              controlId={"dateFromTo"}
            ></SubmitControl>
          </Col>
        </Row>
      </Form.Group>

      <Form.Group
        controlId="classificationStatus"
        className="form-group required"
      >
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.status}</Form.Label>
          </Col>
          <Col>
            <DropDown
              value={props.entity.classificationStatus}
              options={props.statuses.map(x => ({
                value: x,
                label: x.name
              }))}
              onChange={props.onChange}
              targetId={"classificationStatus"}
              placeholder={labels.statusPlaceholder}
              required={
                props.validationRules.classificationStatus &&
                props.validationRules.classificationStatus.required
              }
            />
          </Col>
        </Row>
      </Form.Group>
      <Form.Group
        controlId="classificationType"
        className="form-group required"
      >
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.type}</Form.Label>
          </Col>
          <Col>
            <DropDown
              value={props.entity.classificationType}
              options={props.types.map(x => ({
                value: x,
                label: x.name
              }))}
              onChange={props.onChange}
              targetId={"classificationType"}
              placeholder={labels.typePlaceholder}
              required={
                props.validationRules.classificationType &&
                props.validationRules.classificationType.required
              }
            />
          </Col>
        </Row>
      </Form.Group>

      {props.entity.classificationType ? (
        <Form.Group controlId="classificationParent" className="form-group">
          <Row>
            <Col sm="2">
              <Form.Label className="Label">{labels.parent}</Form.Label>
            </Col>
            <Col>
              <DropDown
                value={props.entity.parent}
                options={props.possibleParents.map(x => ({
                  value: x,
                  label: x.name
                }))}
                onChange={props.onChange}
                targetId={"parent"}
                placeholder={labels.parentPlaceholder}
                isClearable={true}
              />
            </Col>
          </Row>
        </Form.Group>
      ) : null}
    </Form>
  );
};

export default ClassificationGeneralData;
